/*
 *  ************************************************************************
 *  *  © [2015 - 2024] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import get from "lodash/get";
import kebabCase from "lodash/kebabCase";

export const Attribute = ({ data, attributeName = "" }) => {
  const customAttributes = get(data, ["custom_attributes"], []);
  if (!customAttributes.length) {
    return null;
  }
  const currentAttribute = customAttributes.find((attribute) => attribute?.name === attributeName);
  return currentAttribute?.value &&
    (currentAttribute?.type === "rich_text" || currentAttribute?.type === "plain_text") ? (
    <div className={kebabCase(attributeName)} data-test-id={kebabCase(attributeName)} dangerouslySetInnerHTML={{ __html: currentAttribute.value }} />
  ) : null;
};
